/**
* 基础菜单 版本更新日志
*/
<template xmlns="http://www.w3.org/1999/html">
  <div class="contianer rela_box">
    <div class="centre">
      <div class="contre">
<!-- -------------------------------------------- 版本号 2.0.13 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flagA1 = !flagA1" :value='ableA1()'>
            <p>版本号 2.0.13</p>
            <div class="arrow"><p v-text="btnTextA1"></p></div>
          </div>
          <div class="allopname" v-show="flagA1">
            <div class="h40"><p class="item_title ml20">· 新功能 · </p></div>
            <div class="item_content">
              <ol>
                <li>新增批量导入商品基础信息和商品上架信息功能</li>
                <li>新增供货订单管理-“我供货的”页签“出库”功能（预打印出库单），支持在发货前先打印出库单（支持云打印功能）</li>
                <li>新增专属商城批量导入商城商品功能，支持按下载的模版填写信息后将商品批量导入指定的专属商城中</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 优化 ·</p></div>
            <div class="item_content">
              <ol>
                <li>优化快递运费管理，允许一键将快递运费信息设为无效</li>
                <li>优化订单列表显示</li>
                <li>优化店铺分类管理，允许通过搜索栏精准查找待选商品</li>
                <li>优化商品上架管理，新增按上架状态、销量排序筛选项</li>
                <li>优化供货订单管理-“我供货的”页面数据导出，支持按发货信息将供货订单信息导出为excel工作表</li>
                <li>优化专属商城商品查询</li>
                <li>优化专属商城管理</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 修复 ·</p></div>
            <div class="item_content">
              <ol>
                <li>修复客户上传付款凭证图片后，“修改已付款”弹窗中不显示图片的bug</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.13 更新内容 分割线 结束 ------------------------------------ -->
<!-- -------------------------------------------- 版本号 2.0.12 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag91 = !flag91" :value='able91()'>
            <p>版本号 2.0.12</p>
            <div class="arrow"><p v-text="btnText91"></p></div>
          </div>
          <div class="allopname" v-show="flag91">
            <div class="h40"><p class="item_title ml20">· 新功能 · </p></div>
            <div class="item_content">
              <ol>
                <li>新增“是否搜索隐藏”设置，可在商品上架管理中设置商品是否只在专属商城中展示</li>
                <li>新增“供货管理”模块，可支持商家之间的互相供货，支持对供货关系、需供货商品、供货商品、供货订单、供货退货单进行管理</li>
                <li>新增“客户账期管理”页面，支持对客户、被供货商家设置挂账账期</li>
                <li>新增“供货对账单”页面，支持对供货订单及退货单进行对账管理</li>
                <li>新增“结算订单”功能，支持对客户挂账订单进行结算（确认回款）操作</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 优化 ·</p></div>
            <div class="item_content">
              <ol>
                <li>优化商品上架指定/限制查询城市设置逻辑，设置项为互斥项</li>
                <li>优化订单管理“修改已付款”功能，现已支持对客户进行挂账（需要先设置客户账期）</li>
                <li>优化订单管理，新增多种订单筛选条件</li>
                <li>优化专属商城管理，设置商城商品时允许新增代发商品</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.12 更新内容 分割线 结束 ------------------------------------ -->
<!-- -------------------------------------------- 版本号 2.0.11 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag82 = !flag82" :value='ables81()'>
            <p>版本号 2.0.11</p>
            <div class="arrow"><p v-text="btnText82"></p></div>
          </div>
          <div class="allopname" v-show="flag82">
            <div class="h40"><p class="item_title ml20">· 新功能 · </p></div>
            <div class="item_content">
              <ol>
                <li>新增“专属商城管理”功能，支持商家指定客户群体设置专属商城（包含设置商城信息、商品信息、客户单位信息），专属商城仅指定客户才能登录进入</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 优化 ·</p></div>
            <div class="item_content">
              <ol>
                <li>优化发货时的快递信息录入，允许修改快递公司和快递单号，并重新订阅物流轨迹信息</li>
                <li>优化服务费开票列表每页显示数据数量，允许每页显示最多100条数据</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.11 更新内容 分割线 结束 ------------------------------------ -->
<!-- -------------------------------------------- 版本号 2.0.10 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag81 = !flag81" :value='able81()'>
            <p>版本号 2.0.10</p>
            <div class="arrow"><p v-text="btnText81"></p></div>
          </div>
          <div class="allopname" v-show="flag81">
            <div class="h40"><p class="item_title ml20">· 优化 ·</p></div>
            <div class="item_content">
              <ol>
                <li>优化状态信息按钮显示样式</li>
                <li>优化商品基础信息管理输入内容超长的提示</li>
                <li>优化售后审核回复输入框输入限制</li>
                <li>优化订单提现详情列表显示及导出按钮，支持显示订单账号所属客户单位，或者售后单的原订单账号所属客户单位</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 修复 ·</p></div>
            <div class="item_content">
              <ol>
                <li>修复第一次填写的单号错误，修改单号重新订阅物流轨迹时只显示了之前已有物流轨迹系统时间之后的新物流轨迹信息的bug</li>
                <li>修复订单有未发货退货时，订单状态不会变更为已完成的bug</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.10 更新内容 分割线 结束 ------------------------------------ -->
<!-- -------------------------------------------- 版本号 2.0.9 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag71 = !flag71" :value='able71()'>
            <p>版本号 2.0.9</p>
            <div class="arrow"><p v-text="btnText71"></p></div>
          </div>
          <div class="allopname" v-show="flag71">
            <div class="h40"><p class="item_title ml20">· 新功能 · </p></div>
            <div class="item_content">
              <ol>
                <li>新增“议价管理”功能，支持商品设置为议价，商城显示“议价”字样；支持对指定账号设置议价价格并在商城中展示并使用</li>
                <li>新增“修改订单商品”功能，支持在待付款状态下，对客户提交的订单商品进行修改（包含新增、修改、删除操作）</li>
                <li>新增“取消订单原因”显示，客户在商城取消订单时选择的取消原因，在订单详情中显示</li>
                <li>新增关联商品设置商品查询名称功能，关联商品后可设置商品查询名称，如有设置商品搜索列表页显示设置的商品查询名称</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 优化 ·</p></div>
            <div class="item_content">
              <ol>
                <li>优化商品上架操作逻辑，无需下架操作即可对已上架商品修改销售信息</li>
                <li>优化客户已删除的订单在订单管理页面中的显示</li>
                <li>优化修改订单付款状态逻辑，支持对所有“已取消”订单进行修改为已付款状态</li>
                <li>优化商品关联逻辑，商品下架再上架后关联关系保持不变</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.9 更新内容 分割线 结束 ------------------------------------ -->
<!-- -------------------------------------------- 版本号 2.0.8 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag61 = !flag61" :value='able61()'>
            <p>版本号 2.0.8</p>
            <div class="arrow"><p v-text="btnText61"></p></div>
          </div>
          <div class="allopname" v-show="flag61">
            <div class="h40"><p class="item_title ml20">· 优化 ·</p></div>
            <div class="item_content">
              <ol>
                <li>优化新增售后单防并发逻辑</li>
                <li>优化订单发货时的防并发逻辑</li>
                <li>优化上架选择列表图逻辑</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 修复 ·</p></div>
            <div class="item_content">
              <ol>
                <li>修复在线支付订单详情页面显示退款凭证空图片的显示bug</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.8 更新内容 分割线 结束 ------------------------------------ -->
<!-- -------------------------------------------- 版本号 2.0.7 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag51 = !flag51" :value='able51()'>
            <p>版本号 2.0.7</p>
            <div class="arrow"><p v-text="btnText51"></p></div>
          </div>
          <div class="allopname" v-show="flag51">
            <div class="h40"><p class="item_title ml20">· 新功能 · </p></div>
            <div class="item_content">
              <ol>
                <li>新增系统消息模块，支持对公转账审核、售后单审核、对公转账退款、开票申请、商品售罄、商品下架等类型消息的提醒、展示与处理</li>
                <li>新增快递邮费设置功能，支持设置店铺包邮门槛金额、按偏远/非偏远地区设置不同邮费</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 优化 ·</p></div>
            <div class="item_content">
              <ol>
                <li>优化索要发票的开票功能，发票信息列表新增一列“欠票金额”，展示每个订单的欠票金额（动态变化）；开票金额不允许填入，直接取该开票申请的总开票金额</li>
                <li>优化订单物流信息更新功能，如果物流信息更新失败，则自动重新刷新物流信息</li>
                <li>优化服务费开票，电子发票开票完成后下载发票功能</li>
                <li>优化商品上架时的列表图片上传功能，支持从商品图片（2000*2000）中选择一张，系统自动裁剪至指定尺寸并填入，无需人工上传</li>
                <li>优化服务费开票中的发票类型名称显示</li>
                <li>优化订单添加发票功能，发票代号修改为选填项，且所有发票类型均可上传电子发票文件，且上传的电子发票客户可在商城订单中进行查看/下载</li>
                <li>优化订单发货功能，普通模式下，快递公司新增“自提”选项，选择“自提”时可不填快递单号；当选择“自提”选项，且本次发货后订单所有商品均已发货，则该订单状态变更为“已完成”</li>
                <li>优化商品基础信息管理功能：复制商品时，如果被复制商品分类为无效状态，则复制的新商品信息中分类和品牌信息为空值</li>
                <li>优化销售标签管理功能：销售标签列表新增状态字段，可通过开关快速更改销售标签状态（有效/无效），新增的销售标签默认状态为有效；销售标签列表字段新增结束时间，结束时间到期后，销售标签状态变更为无效；销售标签状态变更为无效后，设置了该标签的商品自动重新发布，删除标签</li>
                <li>优化页面推荐管理功能：</li>
                <p class="f14">a、位置名称：店铺秒杀，在店铺首页展示逻辑优化：</p>
                <ul class="ml30 padding">
                  <li class="listdisc">页面推荐设置状态为无效时，不在店铺首页显示</li>
                  <li class="listdisc">营销管理-秒杀管理，秒杀商品有效状态为无效时，不在店铺首页显示</li>
                  <li class="listdisc">营销管理-秒杀管理，秒杀商品活动结束时，不在店铺首页显示</li>
                  <li class="listdisc">营销管理-秒杀管理，秒杀商品已成交数=秒杀数量时，不在店铺首页显示</li>
                  <li class="listdisc">商品管理-商品上架管理，秒杀商品状态为已下架时，不在店铺首页显示</li>
                </ul>
                <p class="f14">b、位置名称：店铺拼团，在店铺首页展示逻辑优化：</p>
                <ul class="ml30 padding">
                  <li class="listdisc">页面推荐设置状态为无效时，不在店铺首页显示</li>
                  <li class="listdisc">营销管理-拼团管理，拼团商品有效状态为无效时，不在店铺首页显示</li>
                  <li class="listdisc">商品管理-商品上架管理，拼团商品状态为已下架时，不在店铺首页显示</li>
                </ul>
                <p class="f14">c、位置名称：店铺分类，在店铺分类展示逻辑优化：</p>
                <ul class="ml30 padding">
                  <li class="listdisc">页面推荐设置状态为无效时，不在店铺分类显示</li>
                  <li class="listdisc">商品管理-商品上架管理，商品状态为已下架时，不在店铺分类显示</li>
                </ul>
                <li>优化订单管理功能：订单多次退货时，退款凭证有多张，订单详情中的退款凭证显示多张</li>
                <li>优化拼团管理功能，拼团新增/修改时增加结束时间选择项（不得小于当前系统时间），结束时间到期后，拼团状态变更为无效</li>
                <li>优化订单满减管理功能，订单满减新增/修改时增加结束时间选择项（不得小于当前系统时间），结束时间到期后，订单满减状态变更为无效</li>
                <li>优化订单满赠管理功能，订单满赠新增/修改时增加结束时间选择项（不得小于当前系统时间），结束时间到期后，订单满赠状态变更为无效</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 修复 ·</p></div>
            <div class="item_content">
              <ol>
                <li>修复动态属性没填入内容时，无法删除的bug</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.7 更新内容 分割线 结束 ------------------------------------ -->

<!-- -------------------------------------------- 版本号 2.0.6 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag41 = !flag41" :value='able41()'>
            <p>版本号 2.0.6</p>
            <div class="arrow"><p v-text="btnText41"></p></div>
          </div>
          <div class="allopname" v-show="flag41">
            <div class="h40"><p class="item_title ml20">· 新功能 · </p></div>
            <div class="item_content">
              <ol>
                <li>新增商家为客户申请售后单功能，支持商家为客户申请售后单。未发货商品退货售后单自动审核并退款（仅在线支付，线下支付的需上传退款凭证手动确认退款）；已发货商品退货售后单自动完成审核步骤；维修售后单自动完成审核步骤</li>
                <li>新增快递设置管理，商家可自行配置为订单发货的快递公司信息（暂未关联至商城前端）</li>
                <li>新增绑定打印机功能，商家可配置打印快递电子面单的打印机</li>
                <li>商家发货时新增发货模式选项，可选择“电子面单模式”并配合快递设置、绑定打印机功能，打印快递电子面单</li>
                <li>新增入驻协议管理，支持查看商家签署的入驻协议信息，并可预览入驻协议pdf文档</li>
                <li>优惠券管理中，新增优惠券类型选择项：活动优惠券、客服赠送券，其中仅客服赠送券可通过松小佰APP发送给客户</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 优化 ·</p></div>
            <div class="item_content">
              <ol>
                <li>优化商品上架管理，列表中可查看限购数量、起购数量内容；松佰体系下子公司上架中授权erp库存数量、erp商品基价字段，可显示相应字段数据</li>
                <li>优化财务管理-服务费开票-开票记录列表中的单据号显示，开票记录列表中的单据号，鼠标悬浮交互时，优化为只显示最多5个单据号</li>
                <li>优化服务费开票流程，入驻商家申请服务费开票后，系统将自动开具电子发票，并发邮件/短信至相应邮箱/手机号</li>
                <li>优化线下支付订单取消时，欠票金额显示</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 修复 ·</p></div>
            <div class="item_content">
              <ol>
                <li>修复订单内开票信息获取错误的bug</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.6 更新内容 分割线 结束 ------------------------------------ -->

<!-- -------------------------------------------- 版本号 2.0.5 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag31 = !flag31" :value='able31()'>
            <p>版本号 2.0.5</p>
            <div class="arrow"><p v-text="btnText31"></p></div>
          </div>
          <div class="allopname" v-show="flag31">
            <div class="h40"><p class="item_title ml20">· 新功能 · </p></div>
            <div class="item_content">
              <ol>
                <li>新增复制商品基础信息功能，支持对不同型号规格的商品进行批量复制、录入商品基础信息</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 优化 ·</p></div>
            <div class="item_content">
              <ol>
                <li>优化松佰牙科ERP数据导入功能，支持导入商品证件信息</li>
                <li>优化登录页面、操作页面系统名称和logo展示</li>
                <li>优化商品基础信息新增/修改时商品编号提示语展示</li>
                <li>优化订单导出表格内容，导出表格中新增会员单位信息字段</li>
                <li>优化基础信息管理中，适用范围输入框调整为非必填项</li>
                <li>优化订单提现逻辑</li>
                <li>优化版本更新日志展示，可预览/下载操作手册文档</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 修复 ·</p></div>
            <div class="item_content">
              <ol>
                <li>修复商户平台基础信息维护修改时没有动态属性输入框的bug</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.5 更新内容 分割线 结束 ------------------------------------ -->

<!-- -------------------------------------------- 版本号 2.0.4 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag21 = !flag21" :value='able21()'>
            <p>版本号 2.0.4</p>
            <div class="arrow"><p v-text="btnText21"></p></div>
          </div>
          <div class="allopname" v-show="flag21">
            <div class="h40"><p class="item_title ml20">· 优化· </p></div>
            <div class="item_content">
              <ol>
                <li>优化订单添加发票逻辑，当客户下单选择“需要发票”时，订单最后一个包裹完成发货后即可进行添加发票操作</li>
                <li>优化服务费开票记录明细导出功能</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 修复· </p></div>
            <div class="item_content">
              <ol>
                <li>修复客服系统切出其他页签页面1分钟以上客服系统掉线的bug</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.4 更新内容 分割线 结束 ------------------------------------ -->

<!-- -------------------------------------------- 版本号 2.0.3 更新内容 分割线 开始 ------------------------------------ -->
        <div class="allope">
          <div class="allopse"  @click="flag11 = !flag11" :value='able11()'>
            <p>版本号 2.0.3</p>
            <div class="arrow"><p v-text="btnText11"></p></div>
          </div>
          <div class="allopname" v-show="flag11">
            <div class="h40"><p class="item_title ml20">· 新功能 ·</p></div>
            <div class="item_content">
              <ol>
                <li>新增页面推荐管理模块，支持对店铺首页商品推荐位置信息进行管理</li>
                <li>新增商品评价管理模块，支持对客户在商城前台填写的商品评价进行审核和回复</li>
                <li>新增商品咨询管理模块，支持对客户在商城前台填写的商品咨询进行回复</li>
                <li>新增客服系统断线重连功能，支持客服系统断开时自行进行重现连接</li>
                <li>新增登录后的公告弹窗功能，支持登录后弹窗显示设置的公告信息</li>
                <li>订单管理新增“上传/修改退款凭证”功能，支持对“已取消”状态的线下转账订单进行上传退款凭证图片</li>
                <li>新增版本更新日志页面，支持展示/查看当前及历史版本更新日志信息</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 优化· </p></div>
            <div class="item_content">
              <ol>
                <li>优化电子发票填写逻辑，支持上传电子发票pdf文件</li>
                <li>优化订单提现逻辑</li>
                <li>优化拼团、秒杀管理逻辑，商品下架时拼团、秒杀活动立即失效；已下架拼团、秒杀商品状态不能设置为有效</li>
                <li>优化商户平台左侧菜单栏显示</li>
              </ol>
            </div>
            <div class="h40"><p class="item_title ml20">· 修复· </p></div>
            <div class="item_content">
              <ol>
                <li>修复一些已知bug</li>
              </ol>
            </div>
          </div>
        </div>
<!-- -------------------------------------------- 版本号 2.0.3 更新内容 分割线 结束 ------------------------------------ -->
      </div>

      <div class="tree">
        <!-- <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree> -->
        <el-row class="tac">
          <el-col :span="12">
            <el-menu :default-active="activeIndex" default-active="2" class="el-menu-vertical-demo" @select="handleSelect" collapse-transition
                     :unique-opened="true" background-color="#ffffff"
              text-color="#333333" active-text-color="#409EFF">
<!-- --------------------------------------------- 2025年4月 更新日期 分割线 开始 -------------------------------------- -->
              <el-submenu index="A1">
                <template slot="title">
                  <span>2025年4月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="A1-1" @click="dateA1()">2025-04-17</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2025年4月 更新日期 分割线 结束 -------------------------------------- -->
<!-- --------------------------------------------- 2024年12月 更新日期 分割线 开始 -------------------------------------- -->
              <el-submenu index="9">
                <template slot="title">
                  <span>2024年12月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="9-1" @click="date91()">2024-12-26</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2024年9月 更新日期 分割线 结束 -------------------------------------- -->
<!-- --------------------------------------------- 2024年9月 更新日期 分割线 开始 -------------------------------------- -->
              <el-submenu index="8">
                <template slot="title">
                  <span>2024年09月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="8-1" @click="date81()">2024-09-03</el-menu-item>
                  <el-menu-item index="8-2" @click="date82()">2024-09-24</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2024年9月 更新日期 分割线 结束 -------------------------------------- -->
<!-- --------------------------------------------- 2024年7月 更新日期 分割线 开始 -------------------------------------- -->
              <el-submenu index="7">
                <template slot="title">
                  <span>2024年07月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="7-1" @click="date71()">2024-07-26</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2024年7月 更新日期 分割线 结束 -------------------------------------- -->
<!-- --------------------------------------------- 2024年5月 更新日期 分割线 开始 -------------------------------------- -->
              <el-submenu index="6">
                <template slot="title">
                  <span>2024年05月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="6-1" @click="date61()">2024-05-24</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2024年5月 更新日期 分割线 结束 -------------------------------------- -->
<!-- --------------------------------------------- 2024年4月 更新日期 分割线 开始 -------------------------------------- -->
              <el-submenu index="5">
                <template slot="title">
                  <span>2024年04月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="5-1" @click="date51()">2024-04-26</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2024年4月 更新日期 分割线 结束 -------------------------------------- -->
<!-- --------------------------------------------- 2024年3月 更新日期 分割线 开始 -------------------------------------- -->
              <el-submenu index="4">
                <template slot="title">
                  <span>2024年03月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="4-1" @click="date41()">2024-03-28</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2024年3月 更新日期 分割线 结束 -------------------------------------- -->
<!-- --------------------------------------------- 2023年12月 更新日期 分割线 开始 ------------------------------------- -->
              <el-submenu index="3">
                <template slot="title">
                  <span>2023年12月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="3-1" @click="date31()">2023-12-04</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2023年12月 更新日期 分割线 结束 ------------------------------------- -->
<!-- --------------------------------------------- 2023年11月 更新日期 分割线 开始 ------------------------------------- -->
              <el-submenu index="2">
                <template slot="title">
                  <span>2023年11月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="2-1" @click="date21()">2023-11-13</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2023年11月 更新日期 分割线 结束 ------------------------------------- -->
<!-- --------------------------------------------- 2023年10月 更新日期 分割线 开始 ------------------------------------- -->
              <el-submenu index="1">
                <template slot="title">
                  <span>2023年10月</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item index="1-1" @click="date11()">2023-10-24</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
<!-- --------------------------------------------- 2023年10月 更新日期 分割线 结束 ------------------------------------- -->
            </el-menu>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="flex-end mr100">
      <el-button type="primary" size="mini" v-on:click="openPdf()" target="_blank"><p class="flex_align preview"><i class="icon"></i>预览操作手册</p></el-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeIndex: '',
        flag11: false,
        flag21: false,
        flag31: false,
        flag41: false,
        flag51: false,
        flag61: false,
        flag71: false,
        flag81: false,
        flag82: false,
        flag91: false,
        flagA1: false,
      }
    },
    methods: {
      openPdf(){
        window.open("./static/img/商户平台操作说明手册V2.2.pdf")
      },
      handleSelect() {
        console.log();
      },
	    able11(){
	    	if(this.flag11){
	    		this.btnText11 = "收起"
	    	} else{
	    		this.btnText11 = "展示"
	    	};
	    },
	    able21(){
	    	if(this.flag21){
	    		this.btnText21 = "收起"
	    	} else{
	    		this.btnText21 = "展示"
	    	};
	    },
	    able31(){
	    	if(this.flag31){
	    		this.btnText31 = "收起"
	    	} else{
	    		this.btnText31 = "展示"
	    	};
	    },
      able41(){
        if(this.flag41){
          this.btnText41 = "收起"
        } else{
          this.btnText41 = "展示"
        };
      },
      able51(){
        if(this.flag51){
          this.btnText51 = "收起"
        } else{
          this.btnText51 = "展示"
        };
      },
      able61(){
        if(this.flag61){
          this.btnText61 = "收起"
        } else{
          this.btnText61 = "展示"
        };
      },
      able71(){
        if(this.flag71){
          this.btnText71 = "收起"
        } else{
          this.btnText71 = "展示"
        };
      },
      able81(){
        if(this.flag81){
          this.btnText81 = "收起"
        } else{
          this.btnText81 = "展示"
        };
      },
      ables81(){
        if(this.flag82){
          this.btnText82 = "收起"
        } else{
          this.btnText82 = "展示"
        };
      },
      able91(){
        if(this.flag91){
          this.btnText91 = "收起"
        } else{
          this.btnText91 = "展示"
        };
      },
      ableA1(){
        if(this.flagA1){
          this.btnTextA1 = "收起"
        } else{
          this.btnTextA1 = "展示"
        };
      },
	    date11() {
	      this.flag11 = !this.flag11
	    },
	    date21() {
	      this.flag21 = !this.flag21
	    },
	    date31() {
        this.flag31 = !this.flag31
      },
      date41() {
        this.flag41 = !this.flag41
      },
      date51() {
        this.flag51 = !this.flag51
      },
      date61() {
        this.flag61 = !this.flag61
      },
      date71() {
        this.flag71 = !this.flag71
      },
      date81() {
        this.flag81 = !this.flag81
      },
      date82() {
        this.flag82 = !this.flag82
      },
      date91() {
        this.flag91 = !this.flag91
      },
      dateA1() {
        this.flagA1 = !this.flagA1
      },
    }
  }

</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .rela_box {
    position: relative;
  }

  .centre {
    display: flex;
    justify-content: space-between;
  }

  .flex_align {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flex-end {
    display: flex;
    justify-content: flex-end;
  }

  .mr100 {
    margin-right: 100px;
  }

  .contre {
    width: 100%;
    height: 720px;
    overflow: auto;
  }

  .tree {
    width: 320px;
    height: 700px;
    overflow: auto;
  }

  .collapse {
    width: 50%;
    height: 735px;
    overflow: auto;
  }

  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    background-color: #fff;
  }

  /deep/ .el-collapse-item__header {
    border-bottom: 0;
    background-color: #F5F7FA;
  }

  /deep/ .el-collapse {
    border-top: 0;
    border-bottom: 0;
  }

  /deep/ .el-collapse-item__wrap {
    border-bottom: 0;
  }

  .ml20 {
    margin-left: 20px;
  }

  .ml30 {
    margin-left: 30px;
  }

  .h40 {
    height: 40px;
  }

  .item p {
    font-weight: 500;
    font-size: 20px;
    color: #409EFF;
  }

  .item_title {
    font-weight: 500;
    font-size: 14px;
    line-height: 40px;
    color: #409EFF;
  }

  .item_content {
    padding: 8px 12px 9px 12px;
    border-bottom: 1px solid #EBEEF5;
  }

  .item_content ol li {
    font-size: 14px;
    line-height: 23px;
    color: #333333;
    font-weight: 400;
  }

  /deep/ .el-submenu__icon-arrow {
      left: 0;
      margin-top: -3px;
      right: auto;
  }

  .allope {
    width: 50%;
    margin-bottom: 20px;
  }

  .allopse {
    background: #EBEEF5;
    padding: 8px 12px 9px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .allopse p {
    font-size: 20px;
    line-height: 28px;
    color: #409EFF;
    font-weight: 500;
  }

  .allopse .arrow {
    padding: 2px 24px;
    border-radius: 4px;
    border: 1px solid #86A8F3;
    background: #FFFFFF;
  }

  .allopse .arrow p {
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    color: #86A8F3;
  }

  .icon {
    width: 20px;
    height: 20px;
    background: url("/static/img/preview.png") no-repeat;
    background-size: 100%;
    display: inline-block;
    margin-right: 10px;
  }

  .preview {
    font-size: 12px;
    line-height: 20px;
    color: #ffffff;
  }

  /deep/ .el-button--mini {
      font-size: 12px;
      border-radius: 4px;
  }
  /deep/ .el-button--mini, .el-button--mini.is-round {
      padding: 2px 12px;
  }

  /deep/ .item_content ol li {
    margin: 10px 0;
  }

  .listdisc {
    list-style-type:disc;
  }

  .padding {
    padding: 0;
  }

</style>





// WEBPACK FOOTER //
// src/views/version/versionAuto.vue